<script setup lang="ts">

import type { IOfferTile } from "@domain/Marketplace";
import { OfferHeaderStyle } from "../../Types/OfferHeaderStyle";
import OfferHeader from "./OfferHeader.vue";
import { useRouter } from "@library/Services";

type Props =
{
    offer: IOfferTile,
    headerStyle?: OfferHeaderStyle,
    enableClickToOpen?: boolean
};

const { offer, headerStyle = OfferHeaderStyle.Large, enableClickToOpen = true } = defineProps<Props>();

/**
 * If enabled, navigates to the offer page
 */
function onClick()
{
    if( enableClickToOpen == false ) return;
    const router = useRouter();
    router.go( `/my-marketplace/offer/${ offer.offerId }` );
}

</script>

<template>

    <div class="w-full rounded-[8px] overflow-hidden cursor-pointer"
         @click="() => onClick()">
        <OfferHeader :offer="offer" :header-style="headerStyle">
            <template #actions>
                <Button color="#f16d15"
                        variant="flat"
                        class="w-full rounded-lg lg:!h-11"
                        :to="`/my-marketplace/offer/${ offer.offerId }`">
                    Full Details
                </Button>
                <Button variant="text"
                        class="w-full lg:!h-11"
                        disabled>
                    <Icon name="heart" />
                </Button>
            </template>
        </OfferHeader>
        <div class="z-10 absolute left-0 top-0 w-full h-full opacity-30 pointer-events-none"
             style="background: linear-gradient(105deg, rgba(255,255,255,0.02) 0%, rgba(255,255,255,0.25) 62%, rgba(248,249,251,0) 100%);">
        </div>
    </div>

</template>
